import React from 'react';

const CircularProgress = ({
  size = 24,
  strokeWidth = 2,
  stages = 4,
  currentStage = 0,
  color = '#048848',
  mr = ''
}) => {
  const radius = (size / 2) - (strokeWidth / 2);
  const circumference = 2 * Math.PI * radius;
  const stagePercentage = 100 / stages;
  const percentage = stagePercentage * currentStage;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: mr }}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#E6E0EC"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{
          transition: `stroke-dashoffset 0.6s ease-in-out`
        }}
      />
    </svg>
  );
};

export default CircularProgress;
